import React from 'react'
import {
  // BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'
// import ApolloClient from 'apollo-boost'
// import { ApolloProvider } from 'react-apollo'
// import { GraphQLClient, ClientContext } from 'graphql-hooks'

import Home from '../Home'
import Event from '../Event'
import Slip from '../Slip'
import CreateEcer from '../CreateEcer/CreateEcer'
import GenerateEcer from '../CreateEcer/GenerateEcer'
import GenWithApi from '../CreateEcer/WithApi'
import ReGenerate from '../CreateEcer/ReGenerate'

// const clientResults = new ApolloClient({
//   uri: process.env.REACT_APP_GRAPHQL_URI,
// })

// const clientRace = new GraphQLClient({
//   url: process.env.REACT_APP_RACE_API,
// })

const RouterApp = () => (
  <Switch>

    {/* <ApolloProvider client={clientResults} > */}
    <Route exact path="/" component={Home} />
    <Route exact name="createEcer" path="/create-ecer" component={CreateEcer} />
    <Route name="generateEcer" path="/generate-ecer" component={GenerateEcer} />
    <Route name="reGenerate" path="/regenerate-ecer" component={ReGenerate} />
    <Route name="genWithApi" path="/create-ecer-api" component={GenWithApi} />
    <Route name="slip" path="/:slug/:bib" component={Slip} />
    <Route name="event" path="/:slug" component={Event} />
    {/* </ApolloProvider> */}
    {/* <ClientContext.Provider value={clientRace} >
      <Route name="generateEcer" path="/generate-ecer" component={GenerateEcer} />
    </ClientContext.Provider> */}

  </Switch>
)

export default RouterApp



// WEBPACK FOOTER //
// ./src/Router/index.js